import { render, staticRenderFns } from "./LibraryMemberDetail.vue?vue&type=template&id=52d5442e"
import script from "../../controllers/library_member/library-member-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/library_member/library-member-detail.js?vue&type=script&lang=js&external"
import style0 from "./LibraryMemberDetail.vue?vue&type=style&index=0&id=52d5442e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports